module.exports = __webpack_public_path__ + "static/media/Location.13ea5454.svg";